export const RELATED_VIEWS_FETCH_LIMIT = 6;
export const WATCH_DATASET_ACTIVITY = 'WATCH_DATASET';
